import { type FunctionComponent } from 'react';
import { PlaceholderImage } from '../images/placeholder-image/placeholder-image.component';

const GroupItemSkeleton: FunctionComponent = () => {
	return (
		<div className="dib w-100-ns">
			<div className="ml1 mv1 mr3 shadow-1-ns h4 tc pt2" data-testid="groupItemSkeleton">
				<PlaceholderImage width={110} height={110} bypassLazyLoad />
			</div>
			<div className="tc ml1 mr3">
				<PlaceholderImage className="br2" width={130} height={16} bypassLazyLoad />
			</div>
		</div>
	);
};

const GroupTabSkeleton: FunctionComponent<{ itemCount?: number }> = ({ itemCount = 4 }) => {
	return (
		<div className="b--theme-grey-light bt-ns br bl pa2 flex overflow-x-auto">
			{Array.from({ length: itemCount }).map((_, index) => (
				<GroupItemSkeleton key={index} />
			))}
		</div>
	);
};

const TabHeadersSkeleton: FunctionComponent<{ tabCount?: number }> = ({ tabCount = 3 }) => {
	return (
		<div className="bg-theme-white flex">
			{Array.from({ length: tabCount }).map((_, index) => (
				<div
					key={index}
					className="w-100 pa3 pa2-ns bt br bl b--theme-grey-light flex justify-between items-center f6 f7-ns mw4-ns tc fw6 br--top-ns br2-ns mr1 bg-theme-grey-light-ns">
					<PlaceholderImage className="br2 center" width={60} height={16} bypassLazyLoad />
				</div>
			))}
		</div>
	);
};

export type GroupContentSkeletonProps = {
	tabCount?: number;
	itemsPerTab?: number;
};

export const GroupContentSkeleton: FunctionComponent<GroupContentSkeletonProps> = ({ tabCount = 3, itemsPerTab = 4 }) => {
	return (
		<div data-testid="group-content-skeleton" className="bb b--theme-grey-light">
			<TabHeadersSkeleton tabCount={tabCount} />
			<GroupTabSkeleton itemCount={itemsPerTab} />
		</div>
	);
};
